module.exports = __webpack_public_path__ + "img/legato_light1.7113b43a.jpg";